module.exports = __webpack_public_path__ + "static/media/add.36fdeabb.svg";